import { DatePicker } from "@/components/shared/date-picker";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";

interface RiderPayrollMarkPaidDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  paymentDate: string;
  onPaymentDateChange: (date: string) => void;
  onConfirm: () => void;
  isPending: boolean;
}

export function RiderPayrollMarkPaidDialog({
  open,
  onOpenChange,
  paymentDate,
  onPaymentDateChange,
  onConfirm,
  isPending,
}: RiderPayrollMarkPaidDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Tandai Dibayar</DialogTitle>
        </DialogHeader>
        <div className="space-y-2 py-2">
          <Label>Tanggal Pembayaran</Label>
          <DatePicker value={paymentDate} onChange={onPaymentDateChange} />
        </div>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Batal
          </Button>
          <Button type="button" onClick={onConfirm} disabled={isPending}>
            {isPending ? "Memproses..." : "Konfirmasi"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
